import React from 'react'
import { Container } from '@material-ui/core'

function LeftPanelNoBookingData(props) {

    function PING_STATIC_IMAGE(filename) {
        const PING_STATIC_IMAGE_DIR = `${process.env.PUBLIC_URL}/static/images/ping/`
        return (PING_STATIC_IMAGE_DIR + filename)
    }

    //* return JSX -------------------------------------------------------------
    return (
        //* Start JSX ----------------------------------------------------------

        <Container className="no_booking_data">
            <img src={PING_STATIC_IMAGE("left_panel_no_booking_data.svg")} />
            <label>No booking found</label>
        </Container>

        //* End JSX ------------------------------------------------------------
    );

    //* End of function --------------------------------------------------------
}

export default LeftPanelNoBookingData